import { render, staticRenderFns } from "./el-descriptions-item.vue?vue&type=template&id=5a475942&scoped=true"
import script from "./el-descriptions-item.vue?vue&type=script&lang=js"
export * from "./el-descriptions-item.vue?vue&type=script&lang=js"
import style0 from "./el-descriptions-item.vue?vue&type=style&index=0&id=5a475942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a475942",
  null
  
)

export default component.exports